<template>
  <div>
    <h4>{{ $t("room.illumination.ra.title") }}</h4>
    <v-row class="mx-0 my-3 d-flex justify-space-between align-baseline">
      <span class="caption black20">
        {{ $t("tests.illumination.measurement_card.required") }}
      </span>
      <span class="body2">{{ requiredRaLabel }}</span>
    </v-row>
    <v-row class="mx-0 my-3 d-flex justify-space-between align-baseline">
      <span class="caption black20">
        {{ $t("tests.illumination.measurement_card.measured") }}
      </span>
      <span class="body2">{{ measuredRaLabel }}</span>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "ra-card-info",
  props: ["test"],
  computed: {
    requiredRaLabel() {
      const { required_ra } = this.test;
      if (Number.isInteger(required_ra) && required_ra >= 0) {
        return `${required_ra} Ra`;
      }
      return "-";
    },
    measuredRaLabel() {
      const { measured_ra } = this.test;
      if (Number.isInteger(measured_ra) && measured_ra >= 0) {
        return `${measured_ra} Ra`;
      }
      return "-";
    },
  },
};
</script>

<style scoped>
.black20 {
  color: #333333;
  font-weight: 500;
}
</style>
